import moment from "moment";
import BenefitPlan from "../../../../app/domain/BenefitPlan";
import { MonetaryAmount } from "../../../../app/domain/monetary-amount";

export default function adaptBenefitPlan({
  id,
  name,
  employees,
  benefitBagConfig,
  allowedBenefits = [],
}) {
  let result = new BenefitPlan({ id, name, employees });

  const annualBag = benefitBagConfig?.find(
    ({ periodDurationInPayrolls, state }) =>
      periodDurationInPayrolls === 12 && state === "active"
  );

  const includedBenefits = allowedBenefits
    .filter((benefit) => benefit !== "gift-card-benefit")
    .map((benefit) => benefit.replace("-benefit", ""));

  if (includedBenefits.find((item) => item === "unknown") === undefined) {
    includedBenefits.push("unknown");
  }

  if (annualBag) {
    if (annualBag.accumulableAtPeriodEnd) {
      result = result.modBenefitBagCanBeAccumulated();
    }
    return result
      .modBenefitBagBenefitTypeAvailability({ names: includedBenefits })
      .modBenefitBagAvailabilityDate({
        date: new Date(moment(annualBag.consumableFrom)),
      })
      .modBenefitBagLimitAmount(
        MonetaryAmount.of(annualBag.limitAmount.amountInCents).toUnitary()
      );
  }

  return result.modBenefitBagBenefitTypeAvailability({
    names: includedBenefits,
  });
}

export function adaptBenefitPlanV2({ id, name, employees }) {
  return new BenefitPlan({ id, name, employees });
}
